import React, { useEffect, useState } from "react";
import { useRoomDetail } from "../hooks/useRoomDetail";
import ChatRoom from "./ChatRoom/ChatRoom";
import MemberAndFileSection from "./MemberAndFileSection";
import RoomInfomation from "./RoomInfomation";

export enum SidebarType {
  USER = "user",
  FILE = "file",
}

const RightSection: React.FC = () => {
  const { roomId } = useRoomDetail();
  const [activeSidebar, setActiveSidebar] = useState<SidebarType | null>(null);

  const hiddenSideBar = () => setActiveSidebar(null);

  const showUser = () => {
    setActiveSidebar(SidebarType.USER);
  };

  const showFile = () => {
    setActiveSidebar(SidebarType.FILE);
  };

  useEffect(() => {
    setActiveSidebar(null);
  },[roomId]);

  if (!roomId) return null;

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <RoomInfomation roomId={roomId} showUser={showUser} showFile={showFile} />

      <div className="flex-1 min-h-0 flex flex-wrap overflow-hidden relative">
        <div className="flex-1 border-t border-l lg:border-l-0 border-r md:border-r-0 h-full overflow-y-auto">
          <ChatRoom key={roomId} roomId={roomId} />
        </div>

        <MemberAndFileSection
          roomId={roomId}
          activeSidebar={activeSidebar}
          hiddenSideBar={hiddenSideBar}
        />
      </div>
    </div>
  );
};

export default RightSection;
